import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface NewNotification {
  name: string;
  api_token: string;
}

export interface NewNotificationListInfor {
  errors: unknown;
  newNotification: NewNotification;
  isAuthenticated: boolean;
}

@Module
export default class NewNotificationModule
  extends VuexModule
  implements NewNotificationListInfor
{
  errors = {};
  newNotification = {} as NewNotification;
  isAuthenticated = !!JwtService.getToken();

  get NewNotifications() {
    return this.newNotificationListData;
  }

  @Mutation
  [Mutations.NEW_NOTIFICATIONS_LIST_DATA](newNotifications) {
    this.newNotificationListData = newNotifications;
  }

  @Action
  [Actions.NEW_NOTIFICATION_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("notifications/new", payload)
        .then((data) => {
          this.context.commit(Mutations.NEW_NOTIFICATIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
